module.exports = __webpack_public_path__ + "static/media/ph.605f5220.svg";